var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / AO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF323E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD0D1B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 10.6666667,
    width: 28,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-16.1%",
    width: "110.7%",
    height: "132.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 28,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-14.1%",
    width: "110.7%",
    height: "128.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.9422366,6.17633614 C13.0375311,5.82069207 13.4030891,5.60963708 13.7587331,5.70493162 C15.8925975,6.27669887 17.1589275,8.47004669 16.5871603,10.6039111 C16.49614,10.9436035 16.3640258,11.261311 16.1975996,11.5531181 L17.0364668,12.1119665 C17.3428193,12.3162014 17.4256018,12.7301143 17.2213669,13.0364668 C17.0171319,13.3428193 16.603219,13.4256018 16.2968665,13.2213669 L16.2968665,13.2213669 L15.3474847,12.5881884 C14.3778302,13.4292842 13.0213955,13.789572 11.6881808,13.4323382 C11.3325367,13.3370437 11.1214817,12.9714857 11.2167763,12.6158416 C11.3120708,12.2601976 11.6776288,12.0491426 12.0332728,12.1444371 C12.7923341,12.347827 13.5626856,12.2023339 14.1740738,11.806254 L12.2968665,10.5547002 C11.9905141,10.3504652 11.9077315,9.93655233 12.1119665,9.63019987 C12.3162014,9.32384741 12.7301143,9.24106483 13.0364668,9.4452998 L13.0364668,9.4452998 L15.0840418,10.8103439 C15.1742229,10.638519 15.2469286,10.4541193 15.2992592,10.258819 C15.6804373,8.83624277 14.8362174,7.37401089 13.4136411,6.99283272 C13.057997,6.89753818 12.846942,6.53198021 12.9422366,6.17633614 Z M12.6666667,7.33333333 C13.0348565,7.33333333 13.3333333,7.63181017 13.3333333,8 C13.3333333,8.36818983 13.0348565,8.66666667 12.6666667,8.66666667 C12.2984768,8.66666667 12,8.36818983 12,8 C12,7.63181017 12.2984768,7.33333333 12.6666667,7.33333333 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.1%",
    y: "-6.3%",
    width: "116.3%",
    height: "125.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-AO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#262626",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DD2137",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8D84B",
    xlinkHref: "#path-8"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.9e6553e72be74ee81c33e21c71bfed76.svg";
export { ForwardRef as ReactComponent };